import { useState, useEffect } from "react";
import Loader from "../../components/Loader/Loader";
import { getCenter } from "../../api/centerAPI";
import { Divider, Paper, Stack, Typography } from "@mui/material";
import { CenterData } from "../../types/api/center";
import { getFullName } from "../../utils/getFullName";

const CommonInfoPage = () => {
    const [loading, setLoading] = useState(true);
    const [centerInfo, setCenterInfo] = useState<CenterData>();

    useEffect(() => {
        const centerId = localStorage.getItem("current_center_id") || "";
        setLoading(true);
        getCenter(Number(centerId), (centerInfo: any) => {
            setCenterInfo(centerInfo.data);
            setLoading(false);
        });
    }, []);

    return (
        <div className="container">
            <div className={"pageHeader"}>Общая информация</div>
            <Paper>
                {loading ? (
                    <Loader />
                ) : (
                    <Stack gap={2} sx={{ p: 4 }}>
                        <Typography variant="body1" textAlign={"start"}>
                            Название: <b>{centerInfo?.name}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            Наименование юридического лица, на базе которого создан центр прототипирования (Базовая
                            организация): <b>{centerInfo?.company?.name ?? "не указан"}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            Должность руководителя: <b>{centerInfo?.chief_work_position}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            ФИО руководителя: <b>{centerInfo?.chief_name}</b>
                        </Typography>
                        <Divider />
                        <Typography variant="body1" textAlign={"start"}>
                            Ответственный за ввод данных(ФИО): <b>{getFullName(centerInfo?.manager ?? {})}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            Рабочий телефон: <b>{centerInfo?.manager?.phone ?? "не указан"}</b>
                        </Typography>
                        <Typography variant="body1" textAlign={"start"}>
                            email: <b>{centerInfo?.manager?.email ?? "не указан"}</b>
                        </Typography>
                    </Stack>
                )}
            </Paper>
        </div>
    );
};

export default CommonInfoPage;
